import React from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { menuItemTextStyle,baseFontStyle } from "../../tickets/tickets";
import { CATEGORY_OPTIONS } from "Samarth Module/components/incidentCreation/IncidentForm";
import {
  CR_STATUS_OPTIONS,
  INCIDENT_STATUS_OPTIONS,
  SLA_STATUS_OPTIONS,
} from "../constants/ticketConstants";

const renderMultiSelect = (name,label, value, options, onChange) => (
  <FormControl fullWidth size="small">
    <InputLabel sx={menuItemTextStyle}>{label}</InputLabel>

    <Select
      sx={{
        "& .MuiSelect-select": {
          ...menuItemTextStyle,
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            "& .MuiMenuItem-root": {
              ...menuItemTextStyle,
            },
          },
        },
      }}
      multiple
      name={name}
      value={value}
      label={label}
      onChange={onChange}
      renderValue={(selected) => selected.join(", ")}
    >
      {options.map((option) => (
        <MenuItem key={option} value={option} sx={menuItemTextStyle}>
          <Checkbox sx={{ p: 0.25 }} checked={value.includes(option)} />

          <ListItemText
            primary={option}
            primaryTypographyProps={{
              sx: menuItemTextStyle,
            }}
          />
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

const ExportTicketDetails = (props) => {
  const {
    exportDialog,
    reportedByList,
    exportLoading,
    pageOptions,
    bauTeamDetails,
    handleCloseExportDialog,
    handleExportFieldChange,
    handleExportReport,
    handleOpenCalendar
  } = props;
  dayjs.extend(customParseFormat);
  return (
    <Dialog
      open={exportDialog.open}
      onClose={handleCloseExportDialog}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle
        sx={{
          ...baseFontStyle,
          fontSize: "1rem",
          fontWeight: 600,
        }}
      >
        Export KPI & Ticket Report
      </DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 2,
            mt: 2,
          }}
        >
          <TextField
            sx={{
              "& .MuiInputLabel-root": menuItemTextStyle,
              "& .MuiInputBase-input": menuItemTextStyle,
            }}
            label="From Date"
            value={dayjs(exportDialog.fromDate).format("DD-MM-YYYY")}
            fullWidth
            InputProps={{
              readOnly: true,
            }}
            onClick={(e) => handleOpenCalendar(e, "fromDate")}
          />

          <TextField
            sx={{
              "& .MuiInputLabel-root": menuItemTextStyle,
              "& .MuiInputBase-input": menuItemTextStyle,
            }}
            label="To Date"
            value={dayjs(exportDialog.toDate).format("DD-MM-YYYY")}
            fullWidth
            InputProps={{
              readOnly: true,
            }}
           onClick={(e) => handleOpenCalendar(e, "toDate")}
          />

          {renderMultiSelect(
            'category',
            "Category",
            exportDialog.category,
            CATEGORY_OPTIONS || [],
            handleExportFieldChange,
          )}

          {renderMultiSelect(
            'reportedBy',
            "Reported By",
            exportDialog.reportedBy,
            reportedByList || [],
            handleExportFieldChange,
          )}

          {renderMultiSelect(
            'pageName',
            "Page",
            exportDialog.pageName,
            pageOptions,
            handleExportFieldChange,
          )}

          {renderMultiSelect(
            'assignedTo',
            "Assigned To",
            exportDialog.assignedTo,
            bauTeamDetails?.map((member) => member.name) || [],
            handleExportFieldChange,
          )}

          {renderMultiSelect(
            'status',
            "Status",
            exportDialog.status,
            [...new Set([...INCIDENT_STATUS_OPTIONS, ...CR_STATUS_OPTIONS])],
            handleExportFieldChange,
          )}

          {renderMultiSelect(
            'slaStatus',
            "SLA Status",
            exportDialog.slaStatus,
            SLA_STATUS_OPTIONS,
            handleExportFieldChange,
          )}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          sx={{
            ...menuItemTextStyle,
            textTransform: "none",
          }}
          disabled={exportLoading}
          onClick={handleCloseExportDialog}
        >
          Cancel
        </Button>

        <Button
          sx={{
            ...menuItemTextStyle,
            textTransform: "none",
          }}
          disabled={exportLoading}
          loading={exportLoading}
          variant="contained"
          onClick={handleExportReport}
        >
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportTicketDetails;
